import { IoIosMail } from "react-icons/io"
import { FaLinkedin } from "react-icons/fa"

const data = [
    {id: 1, icon : <IoIosMail />, link: 'mailto:tomfrer123@gmail.com'},

    {id: 2, icon: <FaLinkedin />, link: 'https://www.linkedin.com/in/thomas-frerichs-a2b487271/'},
]

export default data